import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Core2Config } from '../shared';
import { BaseApiPublicLoginTemplateService } from '../shared/base-api-public-login-template.service';
import { BaseApiTemplateService } from '../shared/base-api-template-service.model';
import { MkpLayoutInstanceContainerModel } from '../../../../../models/aggregates/mkp/mkp-layout-instance-container.model';

@Injectable({
  providedIn: 'root'
})
export class MkpLayoutInstancesService extends BaseApiPublicLoginTemplateService<MkpLayoutInstanceContainerModel,MkpLayoutInstanceContainerModel,MkpLayoutInstanceContainerModel> {

  static readonly MKP_LAYOUT_INSTANCES = 'layout-instances/';
  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.MKP_PREFIX + Core2Config.CPCOMMERCE_PREFIX + MkpLayoutInstancesService.MKP_LAYOUT_INSTANCES  + BaseApiTemplateService.BACKOFFICE_EP;

  constructor(http: HttpClient) {
    super();
    this.httpClient = http;
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.MKP_PREFIX + Core2Config.CPCOMMERCE_PREFIX + MkpLayoutInstancesService.MKP_LAYOUT_INSTANCES  + BaseApiTemplateService.BACKOFFICE_EP;
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.MKP_PREFIX + Core2Config.CPCOMMERCE_PREFIX + MkpLayoutInstancesService.MKP_LAYOUT_INSTANCES  + BaseApiTemplateService.BACKOFFICE_EP;
    this.endpoint_path_public_url = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.MKP_PREFIX + Core2Config.CPCOMMERCE_PREFIX + MkpLayoutInstancesService.MKP_LAYOUT_INSTANCES  + BaseApiTemplateService.PUBLIC_EP;
  }
}

